import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import bnvLogo from '../../assets/images/logo_bk.png';
import './Footer.css';

// 인스타그램/네이버 블로그 브랜드 마크 — lucide-react(v1.21)에 브랜드 아이콘이 없어 인라인 SVG로 대체
function InstagramIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="2.5" y="2.5" width="19" height="19" rx="5" stroke="currentColor" strokeWidth="1.75" />
            <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.75" />
            <circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" />
        </svg>
    );
}

function NaverBlogIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <rect width="24" height="24" rx="6" fill="#03C75A" />
            <path d="M13.6 12.6 10.2 7.5H7.5v9h2.9v-5.1l3.4 5.1h2.7v-9h-2.9v5.1Z" fill="#fff" />
        </svg>
    );
}

function AppFooter() {
    return (
        <footer className="app-footer">
            <Container>
                <Row className="align-items-center">
                    <Col md={7} className="footer-content">
                        <img src={bnvLogo} alt="BNV" className="footer-logo" />
                        <div className="footer-text-block">
                            <span className="company-name">비앤브이솔루션(주)</span>
                            <span className="separator"> </span>
                            <span className="company-info">대표 : 박기범</span>
                            <span className="separator"> </span>
                            <span className="company-info">사업자등록번호 : 556-88-02474</span>
                            <span className="separator"> </span>
                            <span className="company-info">고객센터 : 02-6465-6278</span>
                            <span className="copyright"> Copyright ⓒ 2025 BNV</span>
                        </div>
                    </Col>
                    <Col md={5} className="d-flex flex-column align-items-md-end align-items-start footer-links-col">
                        <Nav className="footer-nav">
                            <Link to="/privacy" className="footer-link">개인정보처리방침</Link>
                            <Link to="/terms" className="footer-link">이용약관</Link>
                        </Nav>
                        {/* 링크는 아직 확정 전 — 아이콘만 배치 (준비되는 대로 연결) */}
                        <div className="footer-social">
                            <span className="footer-social-icon" title="Instagram (준비 중)">
                                <InstagramIcon />
                            </span>
                            <span className="footer-social-icon" title="네이버 블로그 (준비 중)">
                                <NaverBlogIcon />
                            </span>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default AppFooter;